/** Yalnızca rakamlardan oluşan, verilen uzunlukta dizge mi? */
function digitsOf(value, length) {
    const text = value.trim();
    if (text.length !== length || !/^\d+$/.test(text))
        return null;
    return [...text].map(Number);
}
/**
 * Vergi Kimlik Numarası (10 hane) kontrol algoritması.
 * İlk 9 hanenin her biri için: t = (hane + 9 − i) mod 10; t ≠ 0 ise t × 2^(9−i) mod 9 (0 çıkarsa 9).
 * Son hane = (10 − toplam mod 10) mod 10.
 */
export function isValidVkn(value) {
    const digits = digitsOf(value, 10);
    if (!digits)
        return false;
    let sum = 0;
    for (let i = 0; i < 9; i += 1) {
        const shifted = (digits[i] + 9 - i) % 10;
        if (shifted === 0)
            continue;
        const weighted = (shifted * 2 ** (9 - i)) % 9;
        sum += weighted === 0 ? 9 : weighted;
    }
    return (10 - (sum % 10)) % 10 === digits[9];
}
/**
 * T.C. Kimlik Numarası (11 hane) kontrol algoritması.
 * İlk hane 0 olamaz. 10. hane = ((tek haneler toplamı × 7) − çift haneler toplamı) mod 10.
 * 11. hane = ilk 10 hanenin toplamı mod 10.
 */
export function isValidTckn(value) {
    const digits = digitsOf(value, 11);
    if (!digits || digits[0] === 0)
        return false;
    const odd = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
    const even = digits[1] + digits[3] + digits[5] + digits[7];
    const tenth = (((odd * 7 - even) % 10) + 10) % 10;
    if (tenth !== digits[9])
        return false;
    const eleventh = digits.slice(0, 10).reduce((total, digit) => total + digit, 0) % 10;
    return eleventh === digits[10];
}
/** Şirket kimliği: tüzel kişi → VKN (10), şahıs şirketi → TCKN (11). Geçersizse null. */
export function classifyTaxId(value) {
    const text = value.trim();
    if (text.length === 10)
        return isValidVkn(text) ? "VKN" : null;
    if (text.length === 11)
        return isValidTckn(text) ? "TCKN" : null;
    return null;
}
//# sourceMappingURL=tax-id.js.map